module.exports = __webpack_public_path__ + "static/media/vehicle.6c715387.svg";